<div [formGroup]="appOptionForm" *ngIf="appOption">
  <div class="page-title modal-header" style="width: 100%;">
    <h2>אפשרויות...</h2>
  </div>
  <div class="column" style="padding: 24px; margin-top: 90px;">

    <div class="form-row">
      <mat-slide-toggle formControlName="testMode">
        מצב בדיקה
      </mat-slide-toggle>
    </div>
    <hr>
    <div class="form-row">
      <mat-slide-toggle formControlName="canChargeMinusAmount">
        אפשר גביה במינוס
      </mat-slide-toggle>
    </div>
    <hr>
    <div class="form-row">
      <mat-slide-toggle formControlName="autoChargePlansPayments">
        גביית הוראות קבע באופן אוטומטי
      </mat-slide-toggle>
    </div>
    <hr>
    <div class="form-row">
      <mat-slide-toggle formControlName="readingOnlyLastNameToPhone">
        הקראת שם משפחה בלבד לזיהוי בטלפון
      </mat-slide-toggle>
    </div>
    <hr>
    <div class="form-row">
      <mat-slide-toggle formControlName="withContactVoiceName">
        שלח שם מוקלט לזיהוי בטלפון
      </mat-slide-toggle>
    </div>
    <hr>
    <div class="form-row">
      <mat-slide-toggle formControlName="iziCountIsSandboxMode">
        קבלות במצב SENDBOX
      </mat-slide-toggle>
    </div>
    <hr>
    <div class="form-row">
      <mat-slide-toggle formControlName="iziCountSendCopy">
       האם לשלוח עותק קבלה למייל השולח?
      </mat-slide-toggle>
    </div>
    <hr>

    <div class="form-row">
      <label>איזיקאונט - API KEY:</label>
      <input type="text" class="form-control" apply-enter formControlName="iziCountApiKey"
        title="איזיקאונט - API KEY...">
    </div>

    <hr>
    <div class="form-row">
      <label>איזיקאונט - כתובת דוא''ל יוצאת לקבלות:</label>
      <input type="text" class="form-control" apply-enter formControlName="iziCountSenderEmail"
        title="איזיקאונט - כתובת דוא''ל יוצאת לקבלות...">
    </div>

    <hr>

    <div class="form-row">
      <label>פורמט כתובת (Address Format):</label>
      <input type="text" class="form-control" apply-enter formControlName="addressFormat"
        title="פורמט כתובת (IL / USA / UK)...">
    </div>
    <hr>

    <div class="form-row">
      <label>תנאי תשלום ברירת מחדל IL:</label>
      <select class="form-control" apply-enter formControlName="defaultIlTermID">
        <option *ngFor="let term of servicesData.Terms" [value]="term.id">
          {{term.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>תנאי תשלום ברירת מחדל USA:</label>
      <select class="form-control" apply-enter formControlName="defaultUsaTermID">
        <option *ngFor="let term of servicesData.Terms" [value]="term.id">
          {{term.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>מיקום חשבון ברירת מחדל:</label>
      <select class="form-control" apply-enter formControlName="defaultAccountLocation">
        <option *ngFor="let al of servicesData.AccountLocations" [value]="al.value">
          {{al.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>מטבע ברירת מחדל (Currency):</label>
      <select class="form-control" apply-enter formControlName="defaultCurrency">
        <option *ngFor="let c of servicesData.Currencies" [value]="c.value">
          {{c.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>קטגוריית תרומה ברירת מחדל:</label>
      <select class="form-control" apply-enter formControlName="defaultDonationCategory">
        <option *ngFor="let dc of servicesData.DonationCategories" [value]="dc.id">
          {{dc.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>שפת ברירת מחדל (Language):</label>
      <select class="form-control" apply-enter formControlName="defaultLanguage">
        <option *ngFor="let l of servicesData.Languages" [value]="l.value">
          {{l.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>שיוך ברירת מחדל (Affiliation):</label>
      <select class="form-control" apply-enter formControlName="defaultAffiliation">
        <option *ngFor="let aff of servicesData.ContactAffiliations" [value]="aff.value">
          {{aff.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>נושא התחייבות ברירת מחדל:</label>
      <select class="form-control" apply-enter formControlName="defaultCommitmentSubject">
        <option *ngFor="let cs of servicesData.CommitmentSubjects" [value]="cs.value">
          {{cs.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>סוג תרומה ברירת מחדל:</label>
      <select class="form-control" apply-enter formControlName="defaultDonationType">
        <option *ngFor="let dt of servicesData.DonationTypes" [value]="dt.value">
          {{dt.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <label>סוג כתובת/מיקום ברירת מחדל:</label>
      <select class="form-control" apply-enter formControlName="defaultLocationType">
        <option *ngFor="let lt of servicesData.LocationTypes" [value]="lt.value">
          {{lt.name}}
        </option>
      </select>
    </div>
    <hr>

    <div class="form-row">
      <mat-slide-toggle formControlName="defaultForPost">
        ברירת מחדל למשלוח דואר
      </mat-slide-toggle>
    </div>
    <hr>

  </div>
  <div class="footer">

    <footer-edit-buttons [dataProvider]="appOptionsData" [router]="router" [id]="id" [disabledDeleteButton]="id <= 0"
      [modelFormGroup]="appOptionForm"></footer-edit-buttons>

    <!-- <footer-edit-buttons [dataProvider]="appOptionsData"
    [router]="router" [id]="id" [disabledDeleteButton]="true" [modelFormGroup]="appOptionForm">
  </footer-edit-buttons> -->

    <!-- <button apply-enter [disabled]="appOptionForm.invalid" (click)="save()" class="btn btn-primary navbar-btn"><i class="fa fa-save"></i> שמור </button>
      <button class="btn btn-warning navbar-btn"><i class="fa fa-warning"></i> יציאה ללא שמירה</button> -->
  </div>
</div>


<ng-template #loading>
  <h3 style="text-align: center;">
    טוען נתונים...
  </h3>
</ng-template>
